import pubsub from './pubsub';
import { throttle } from './throttle';

// Adds a data attribute to your selected element with the scroll direction as value.
// scrollElement is the element on which you have applied scroll.
// targetElement is the child element on which you detect scroll,
// this is where data-attributes will be registered.
// dispatchElement is the element that will dispatch a custom event that can be listened to.

// Use window in case of no scrollElement and targetElement will default to document.body


// Initial state
let scrollPosV = 0;
let scrollPosH = 0;

export function scrollDirection(scrollElement, targetElement, dispatchElement) {
	const scrollEl = scrollElement;
	let targetEl = targetElement;
	let dispatchEl = dispatchElement;

	if (scrollEl === window && !targetEl) {
		targetEl = document.body;
	}

	if (!dispatchEl) {
		dispatchEl = targetEl;
	}

	function setDirection(direction) {
		targetEl.dataset.scrollDirection = direction;
		const customEvent = document.createEvent('CustomEvent');
		customEvent.initCustomEvent('scrollDirection', false, false, {
			detail: targetEl.dataset.scrollDirection,
		});
		dispatchEl.dispatchEvent(customEvent);
		pubsub.publish('window/scrollDirection', { detail: targetEl.dataset.scrollDirection });
	}

	const onScroll = throttle(
		() => {
			// detects new state and compares it with the new one
			if ((targetEl.getBoundingClientRect()).top !== scrollPosV) {
				if ((targetEl.getBoundingClientRect()).top > scrollPosV) {
					setDirection('UP');
				} else {
					setDirection('DOWN');
				}
			}
			if ((targetEl.getBoundingClientRect()).left !== scrollPosH) {
				if ((targetEl.getBoundingClientRect()).left > scrollPosH) {
					setDirection('LEFT');
				} else {
					setDirection('RIGHT');
				}
			}
			// saves the new position for iteration.
			scrollPosV = (targetEl.getBoundingClientRect()).top;
			scrollPosH = (targetEl.getBoundingClientRect()).left;
		}, 250
	);

	// adding scroll event
	scrollElement.addEventListener('scroll', onScroll);
}
